<div class="ops-shell">
  <nav class="ops-nav" aria-label="Ops workspace">
    <div class="ops-nav__head">
      <p class="ops-nav__eyebrow">CapX Ops</p>
      @if (tierLabel(); as tier) {
        <span class="ops-nav__tier">{{ tier }}</span>
      }
    </div>

    <ul class="ops-nav__list">
      @for (item of navItems; track item.path) {
        <li>
          <a
            #anchor
            class="ops-nav__link"
            [routerLink]="item.path"
            routerLinkActive="ops-nav__link--active"
            #rla="routerLinkActive"
            [attr.aria-current]="rla.isActive ? 'page' : null"
            (isActiveChange)="$event && revealActive(anchor)"
          >
            <app-icon class="ops-nav__icon" [name]="item.icon" [size]="18" />
            <span class="ops-nav__label">{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>
  </nav>

  <div class="ops-shell__content">
    <router-outlet />
    <!-- FLOW-348 (DOC-80 UI-DA-80-05): at every Ops page's foot. -->
    <footer class="ops-shell__foot">
      <button type="button" class="ops-shell__terms" (click)="openGlossary()">
        What these terms mean
      </button>
    </footer>
  </div>
</div>
